/* eslint-disable no-console */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment';
import { shortenandHoverString, dateFormate, imageUrl, formatDateOrDash } from '../../../../Components/helper';
import noImage from '../../../../assets/images/no-image.png';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { formatStoredCalendarDate, isStoredCalendarDateBeforeToday } from '../../../../Components/helper';


function SupportingDocumentTabel({
  handleSelectAll,
  supportingDocument,
  selectDocumentCheckBox,
  allSelectedDocuments,
  Documents,
  onDelete,
  onEdit,
  onPreview,
  onRenew,
  onSortColumn,
  archiveSection,
  handleArchiveCard,
  handleDuplicateById,
  isFactoryLevel,
  loading,
}) {
  const { t } = useTranslation('common');
  const [openMoreId, setOpenMoreId] = useState(null);
  const dateFormat = 'DD-MMMM-YYYY';

  const showComment = (item) => {
    return (
      <div className="info-container xs-position-bottom iconfirst testing-action-spaceremoval">
        <span className="icon-chat-bubble f-18" />
        <div className="info-content text-nowrap">
          <p className="text-left m-0">
            {item?.archivedBy?.firstName && (
              <p className="text-left m-0">
                {`${item?.archivedBy?.firstName} ${item.archivedBy?.lastName} | `}
                {formatDateOrDash(item?.archivedAt, dateFormate)}
              </p>
            )}
            {item?.archiveComment && (
              <div className="comment">
                <p className="m-0">{item?.archiveComment}</p>
              </div>
            )}
          </p>
        </div>
      </div>
    );
  };

  const fetchFromS3 = (element) => {
    return element ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${element}`) : '';
  };

  const handleDownload = async (element) => {
    if (element?.s3Key) {
      fetch(fetchFromS3(element?.s3Key))
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', element?.fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch((error) => console.log('Error downloading file:', error));
    } else {
      toasterMsg(t('ADD_EDIT_COMPONENET.NO_DOCUMENT_PREVIEW'), 'danger');
    }
  };

  const actionPanel = (item, index) => {
    const secondaryPanel = (
      <Popover className="supp-doc-action-popup">
        <Popover.Content>
          <ul>
            <li>
              <button
                className="btn"
                onClick={() => handleArchiveCard(item?._id, item)}
                type="button"
                aria-label="archive"
              >
                <i className="icon-Archive f-16" />
                <span className="text">{item?.isArchived ? t('TAKING_DATES.UNARCHIVE') : t('TAKING_DATES.ARCHIVE')}</span>
              </button>
            </li>
            <li>
              <button className="btn" onClick={() => handleDuplicateById(item)} type="button" aria-label="duplicate">
                <i className="icon-Copy f-16" />
                <span className="text">{t('TAKING_DATES.DUPLICATE')}</span>
              </button>
            </li>
            {item.status === 'Pending' && (
              <li>
                <button className="btn" onClick={() => onDelete(item._id, item)} type="button" aria-label="delete">
                  <i className="icon-delete f-16" />
                  <span className="text">{t('TAKING_DATES.DELETES')}</span>
                </button>
              </li>
            )}
          </ul>
        </Popover.Content>
      </Popover>
    );

    const statusComment = Array.isArray(item?.statusComment)
      ? item.statusComment.filter(Boolean).join(', ')
      : item?.statusComment || '';

    const hasInfo = item?.approveBy || statusComment;
    const infoOverlay = (
      <Popover className="custom-popover modified-popover">
        <Popover.Content>
          {hasInfo ? (
            <>
              {item?.approveBy && (
                <p className="text-left m-0">
                  <strong>{item.approveBy}</strong>
                  {` | ${formatDateOrDash(item?.statusDate, dateFormat)}`}
                </p>
              )}
              {statusComment && <p className="text-left m-0">{statusComment}</p>}
            </>
          ) : (
            <p className="text-left m-0">-</p>
          )}
        </Popover.Content>
      </Popover>
    );

    return (
      <>
        {(item.status === 'Pending' || item.status === 'pending') && !archiveSection && (
          <CustomTooltip tooltipText={t('COMMON_LABEL.EDIT')}>
            <button className="btn p-0 text-decoration-none" type="button" aria-label="edit" onClick={(e) => onEdit(e, item._id, index, item)}>
              <i className="icon-Edit-1 f-20" />
            </button>
          </CustomTooltip>
        )}
        <CustomTooltip tooltipText={t('TAKING_DATES.DOWNLOADES')}>
          <button className="btn p-0 text-decoration-none" type="button" aria-label="download" onClick={() => handleDownload(item)}>
            <i className="icon-Download f-20" />
          </button>
        </CustomTooltip>
        <OverlayTrigger
          placement="top"
          trigger={['hover', 'focus']}
          rootClose
          overlay={infoOverlay}
        >
          <button className="btn p-0 text-decoration-none" type="button" aria-label="info">
            <i className="icon-Information f-20" />
          </button>
        </OverlayTrigger>
        {!isFactoryLevel && (
          <CustomTooltip tooltipText={t('TAKING_DATES.RENEW')}>
            <button className="btn p-0 text-decoration-none" type="button" aria-label="renew" onClick={(e) => onRenew && onRenew(e, item, item._id)}>
              <span className="icon-Renew-2 f-20" />
            </button>
          </CustomTooltip>
        )}
        <OverlayTrigger
          placement="left"
          trigger="click"
          rootClose
          show={openMoreId === item._id}
          onToggle={(next) => setOpenMoreId(next ? item._id : null)}
          overlay={secondaryPanel}
        >
          <button className="btn p-0 text-decoration-none" type="button" aria-label="more options">
            <i className={openMoreId === item._id ? 'icon-close f-14' : 'icon-More f-20'} />
          </button>
        </OverlayTrigger>
        {item?.isArchived && (item?.archiveComment ? <span>{showComment(item)}</span> : <span>-</span>)}
      </>
    );
  };

  const approveRejWasArr = (ele) => {
    return !ele?.isExpanded && ele?.approveRejectedBy?.length === 1
      ? `${ele?.approveRejectedBy?.[0]?.firstName} ${ele?.approveRejectedBy?.[0]?.lastName} | `
      : `${ele?.approveRejectedBy?.firstName} ${ele?.approveRejectedBy?.lastName} | `;
  };

  const forCurrentStatus = (ele) => {
    return Array.isArray(ele?.status)
      ? !ele?.status?.[0] || ele?.status?.[0] === 'Pending' || ele?.status?.[0] === 'pending' || ele?.status?.[0] === null
      : !ele?.status || ele?.status === 'Pending' || ele?.status === 'pending' || ele?.status === null;
  };

  const ifoneAppRej = (ele) => {
    return !ele?.approveRejectedBy || (Array.isArray(ele.approveRejectedBy) && isEmpty(ele.approveRejectedBy)) ? '' : approveRejWasArr(ele);
  };

  const forAppRej = (ele) => {
    return !ele?.isExpanded && ele?.approveRejectedBy?.length > 1 ? '' : ifoneAppRej(ele);
  };
  const selectedDataArr = (ele) => {
    return !ele?.isExpanded && ele?.selectedDate?.length === 1 ? moment(ele?.selectedDate[0]).format(dateFormat) : moment(ele?.selectedDate).format(dateFormat);
  };
  const ifoneAppAt = (ele) => {
    return !ele?.selectedDate || !ele?.selectedDate[0] ? '' : selectedDataArr(ele);
  };

  const forCmntApprovedAt = (ele) => {
    return !ele?.isExpanded && ele?.expandData?.length > 1 ? '' : ifoneAppAt(ele);
  };
  const cmntParts = (ele) => {
    if (ele?.approveBy && !isEmpty(ele?.statusComment)) {
      return ele?.statusComment?.length === 1 && forCurrentStatus(ele) ? null : (
        <button aria-label="info" type="button" className="btn p-0 d-inline-flex ml-auto">
          <OverlayTrigger
            trigger={['hover', 'focus']}
            rootClose
            overlay={
              <Popover className="custom-popover modified-popover">
                <div className="p-2">
                  <p className="mb-1">
                    {Array.isArray(ele?.approveBy) && forAppRej(ele)}
                    {!Array.isArray(ele?.approveBy) && ele?.approveBy && `${ele?.approveBy} | `}
                    {Array.isArray(ele?.statusDate) && forCmntApprovedAt(ele)}
                    {!Array.isArray(ele?.statusDate) && formatDateOrDash(ele?.statusDate, dateFormat)}
                  </p>
                  {!isEmpty(ele?.statusComment) && <p className="mb-0 comment-box">{ele?.statusComment}</p>}
                </div>
              </Popover>
            }
          >
            <i className="icon-Information ml-8 f-20" />
          </OverlayTrigger>
        </button>
      );
    }
    return null;
  };

  function getFactoryNames(code) {
    if (code?.length > 0) {
      return code.join(', ');
    }
    return '';
  }

  const setStatusBar = (colourStatus, itemStatus, s3Key, item) => {
    let status = colourStatus;
    if (!status && itemStatus) {
      if (itemStatus === 'Approved') status = 'green';
      else if (itemStatus === 'Rejected') status = 'red';
      else if (itemStatus === 'Rejected' || itemStatus === 'rejected') status = 'red';
      else status = 'amber';
    }

    const statusText = `${s3Key ? t('SUPPLIER_DOCUMENT.UPLOADED') : 'Not Uploaded'} | ${itemStatus}`;

    switch (status) {
      case 'green':
        return (
          <span className="status-badge supporting-badge mr-16 approved">
            {statusText} {cmntParts(item)}
          </span>
        );

      case 'red':
        return (
          <span className="status-badge supporting-badge mr-16 rejected">
            {statusText} {cmntParts(item)}
          </span>
        );

      case 'amber':
        return (
          <span className="status-badge supporting-badge mr-16 pending">
            {statusText} {cmntParts(item)}
          </span>
        );

      default:
        return (
          <span className="status-badge supporting-badge mr-16 deleted">
            {statusText} {cmntParts(item)}
          </span>
        );
    }
  };

  const supplierLogoSrc = (item) => {
    const logo = item?.supplierLogo || item?.supplier?.image;
    if (!logo) return noImage;
    if (String(logo).startsWith('http')) return logo;
    return `${imageUrl}/${logo}`;
  };

  return (
    <table className="table fixed-header common-custom-table m-0">
      <thead>
        {!isFactoryLevel && (
          <th aria-label="checkbox" className="w-50px">
            <div className=" margin-auto">
              <div className="common-checkbox margin-auto">
                <input type="checkbox" onChange={handleSelectAll} name="check_all" id="check_all" checked={allSelectedDocuments} />
                <label htmlFor="check_all" className="chklabel" aria-label="Select all" />
              </div>
            </div>
          </th>
        )}
        <th className="w-59px">{t('SUPPLIER_DOCUMENT.IMAGE')}</th>
        <th className="w-150px">{t('SUPPLIER_DOCUMENT.SUPPLIER')}</th>
        <th className="w-150px">{t('SUPPLIER_DOCUMENT.DOCUMENT_NAME')}</th>
        <th className="w-150px">{t('SUPPLIER_DOCUMENT.DOCUMENT_TYPE')}</th>
        {!isFactoryLevel && <th className="w-150px">{t('SUPPLIER_DOCUMENT.FACTORY')}</th>}
        <th className="w-150px">{t('SUPPLIER_DOCUMENT.COUNTRY_ORIGIN')}</th>
        <th
          className="w-180px"
          onClick={() => {
            onSortColumn('expiredAt');
          }}
        >
          {t('SUPPLIER_DOCUMENT.EXPIRY_DATES')}
        </th>
        <th className="w-350px">{t('SUPPLIER_DOCUMENT.STATUS')}</th>
      </thead>
      <tbody>
        {loading && (
          <tr>
            <td colSpan={9} className="text-center py-3">
              <Loader />
            </td>
          </tr>
        )}
        {!loading &&
          supportingDocument?.length > 0 &&
          supportingDocument.map((item, index) => (
            <tr key={item?._id}>
              {!isFactoryLevel && (
                <td>
                  <div className="margin-auto">
                    <div className="common-checkbox margin-auto">
                      <input
                        onChange={(e) => selectDocumentCheckBox(e, item._id, item)}
                        name={`checks_${index}`}
                        id={`checks_${index}`}
                        type="checkbox"
                        checked={Documents?.includes(item?._id)}
                        aria-label="Select document"
                      />
                      <label htmlFor={`checks_${index}`} className="chklabel" aria-label="Select document" />
                    </div>
                  </div>
                </td>
              )}

              <td className="w-59px">
                <img src={supplierLogoSrc(item)} className="logo img-36" alt={item?.supplierName || item?.supplierCode || 'supplier'} />
              </td>
              <td>{shortenandHoverString(item?.supplierName || item?.supplierCode || '-', 15)}</td>
              <td>
                <div className="d-flex align-items-center justify-content-between">
                  {item.title ? (
                    <Link
                      to={`/supplier/${item?.supplierId || item?.supplier?._id}/supporting-docs?supplierId=${item?.supplierId || item?.supplier?._id}`}
                      className="font-weight-bold text-dark text-decoration-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {shortenandHoverString(item.title, 15)}
                    </Link>
                  ) : (
                    ''
                  )}
                  {item?.s3Key && (
                    <CustomTooltip tooltipText={t('TAKING_DATES.PREVIEW')}>
                      <button className="btn p-0 ml-2" type="button" aria-label="preview" onClick={() => onPreview && onPreview(item)}>
                        <i className="icon-Preview-1 f-16" />
                      </button>
                    </CustomTooltip>
                  )}
                </div>
              </td>
              <td>{(!isEmpty(item?.documentType) && !item?.documentType?.isDeleted ? item?.documentType?.name : '') || '-'}</td>
              {!isFactoryLevel && (
                <td>
                  {getFactoryNames(item?.factoryName) || getFactoryNames(item?.factoryCode)
                    ? shortenandHoverString(getFactoryNames(item?.factoryName) || getFactoryNames(item?.factoryCode), 20)
                    : '-'}
                </td>
              )}
              <td>{getFactoryNames(item?.factoryCountry) ? shortenandHoverString(getFactoryNames(item?.factoryCountry), 20) : '-'}</td>
              <td>
                <span className={isStoredCalendarDateBeforeToday(item?.expiredAt) ? 'text-danger' : ''}>
                  {item?.expiredAt ? formatStoredCalendarDate(item?.expiredAt, 'DD-MMM-YYYY') : null}
                </span>
              </td>
              <td>
                <div className="d-flex align-items-center justify-content-between">
                  {setStatusBar(item?.statusColor || '', item?.status, item?.s3Key, item)}
                  <div className="d-flex pom-action align-items-center ml-auto">{actionPanel(item, index)}</div>
                </div>
              </td>
            </tr>
          ))}{' '}
        {!loading && supportingDocument?.length === 0 && (
          <tr>
            <td colSpan={9}>
              <span className="align-items-center justify-content-center d-flex">{t('SUPPLIER_DOCUMENT.NO_RECORD_FOUND')}</span>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default SupportingDocumentTabel;
